import { render, staticRenderFns } from "./APIEndpointsTable.vue?vue&type=template&id=7f4e5828"
import script from "./APIEndpointsTable.vue?vue&type=script&lang=js"
export * from "./APIEndpointsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports